export default "__VITE_ASSET__C2uW2qMH__"